import React from 'react';
import ChartContainer from './ChartContainer';
import { useServicesChartsDataContext } from '../../hooks/useServicesChartsDataContext';
import useServicesPerMonthPerYearCompareChart from './hooks/useServicesPerMonthPerYearCompareChart';

export const ServicesPerMonthPerYearCompare = ({ height = 400 }) => {
    const { module } = useServicesChartsDataContext();
    const { chartConfig } = useServicesPerMonthPerYearCompareChart();

    return (
        <ChartContainer
            title={`Evolução ${module.sectionTitle} Mensal no Ano Selecionado`}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={height}
        />
    );
};
